<template>
  <div class="mx-n1 row">
    <div class="col-lg-4 pl-1">
      <ListUser
        label=""
        name="targetUserId"
        small
        v-model="onTheFlyConfig.targetUserId"
        placeholder="Usuario"
        @input="onTheFlyChange"
      />
    </div>
    <div class="col-lg-3 pl-1">
      <b-form-group class="mb-3">
        <b-form-input
          id="search"
          placeholder="Busqueda"
          name="search"
          size="sm"
          v-model="onTheFlyConfig.name"
          @input="onTheFlyChange"
        />
      </b-form-group>
    </div>
  </div>
</template>
<script>

import { FILTER_ON_THE_FLY_COMPARATORS } from '../config';

import ListUser from '@/febos/chile/lists/components/ListUser';

export default {
  data() {
    return {
      onTheFlyConfig: {
        targetUserId: '',
        name: ''
      }
    };
  },
  methods: {
    onTheFlyChange() {
      const filters = Object.entries(this.onTheFlyConfig)
        .filter(([, value]) => !!value)
        .reduce((memo, [key, value]) => ({
          ...memo,
          [key]: FILTER_ON_THE_FLY_COMPARATORS[key](value)
        }), {});
      this.$emit('on-the-fly-filters-change', filters);
    }
  },
  components: {
    ListUser
  }
};

</script>
